import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [status, setStatus] = useState('');

  const handleLinkClick = () => {
    setStatus('Preparing your Gmail draft...');

    // Construct the Gmail compose URL
    const to = encodeURIComponent('felixaniekwensi@gmail.com');
    const subject = encodeURIComponent('Contact Form Submission');
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}`;

    try {
      // Open Gmail compose in a new tab
      window.open(gmailLink, '_blank');

      // Update status
      setStatus(
        'Gmail draft opened in a new tab! Please compose your message and click "Send" in Gmail. ' +
        'If you don\'t use Gmail, please email felixaniekwensi@gmail.com directly.'
      );

      // Redirect to homepage after a 2-second delay
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    } catch (error) {
      setStatus(
        'Error opening Gmail. Please email felixaniekwensi@gmail.com directly or ensure you are logged into Gmail.'
      );
      console.error('Error opening Gmail link:', error);
    }
  };

  const handleHomeClick = () => {
    window.location.href = '/';
  };

  return (
    <div className="contact-container">
      <h1 className="text-3xl font-bold text-center">Contact Us</h1>
      <div className="social-links">
        {/* <a href="https://www.facebook.com/emeka.aniekwensi" className="social-icon" target="_blank" rel="noopener noreferrer">Facebook</a> */}
        {/* <a href="https://www.instagram.com/emekaaniekwensi/?hl=en" className="social-icon" target="_blank" rel="noopener noreferrer">Instagram</a> */}
        {/* <a href="https://x.com/emekaaniekwensi" className="social-icon" target="_blank" rel="noopener noreferrer">X</a> */}
        <a href="https://www.linkedin.com/in/emeka-aniekwensi-83a84620a/" className="social-icon" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      </div>
      <div className="contact-form">
        <button
          className="submit-btn"
          onClick={handleLinkClick}
        >
          Email
        </button>
        <button
          className="home-btn"
          onClick={handleHomeClick}
        >
          Home
        </button>
      </div>
      {status && (
        <p className={`status-message ${status.includes('Error') ? 'error' : ''}`}>
          {status}
        </p>
      )}
    </div>
  );
};

export default Contact;